import { render, staticRenderFns } from "./DialogAction.vue?vue&type=template&id=c5ef51ea&scoped=true"
import script from "./DialogAction.vue?vue&type=script&lang=js"
export * from "./DialogAction.vue?vue&type=script&lang=js"
import style0 from "./DialogAction.vue?vue&type=style&index=0&id=c5ef51ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ef51ea",
  null
  
)

export default component.exports